<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Asignación de docente en estancia/estadia" code-toggler>
<div class="">
    <vs-popup style="height: 500px;" class="holamundo"  title="Elija el profesor a asignar:" :active.sync="popupActive">
        <p>   <v-select label="ncompleto" v-model="asignar_select" :options="profesores"></v-select>
            <br/>
            <vs-button  class="float-right"  @click="asignar_profesor_guardar()">Asignar</vs-button>
        </p>
    </vs-popup>

</div>
        <p>{{cuatrimestre_actual[0].nombre}} {{cuatrimestre_actual[0].idAgno}}</p><br>
        <br/><br/>
        <vs-table search pagination :maxItems="50" stripe :data="alumnos">

        <template slot="thead">
                <vs-th>Matricula</vs-th>
                <vs-th>Nombre</vs-th>
                <vs-th>Materia</vs-th>
                <vs-th>Profesor Asignado</vs-th>
                <vs-th>Acciones</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].cuenta">
                        {{data[indextr].matricula}}
                    </vs-td>
                    <vs-td :data="data[indextr].username">
                         {{data[indextr].apellidoPaterno}} {{data[indextr].apellidoMaterno}} {{data[indextr].nombres}}
                    </vs-td>
                    <vs-td :data="data[indextr].username">
                        {{data[indextr].nombre}}
                    </vs-td>
                    <vs-td :data="data[indextr].username">
                        {{data[indextr].asignado}}
                    </vs-td>
                    <vs-td style="text-align: center;" :data="data[indextr].id">
                        <vs-button class=""  @click="asignar_profesor(data[indextr])">Asignar profesor</vs-button>

                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'
    export default {
        data() {
            return {
                carrera: localStorage.getItem('id_carrera'),
                cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
                alumno_detalle: [],
                popupActive: false,
                alumnos: [],
                profesores: [],
                carreras: [],
                asignar_select: '',
                carreras_select: {},
                alumno_asignar : '',
                grupo_asignar: ''
            }
        },
        components: {
            'v-select': vSelect,
        },
        created() {
            this.$vs.loading();
            this.carrera =  localStorage.getItem('id_carrera');
            this.getCuatrimestreActual();




        },
        watch: {
            // whenever question changes, this function will run

        },
        methods: {
            getCuatrimestreActual(){
                this.$http.get("cuatrimestre_actual").then(
                    response => {
                        // console.log(response.data)
                        this.cuatrimestre_actual = response.data.cuatrimestre_actual;
                        //console.log(this.kardex);
                        this.getAlumnos();
                        this.getCarreras();
                        this.getProfesores();

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },

            asignar_profesor_guardar(){
                console.log(this.asignar_select)
                this.$http.get("agregar_alumno_estancia/" + this.alumno_asignar + "/" + this.asignar_select.id+ "/" + this.grupo_asignar).then(
                    response => {
                        //location.reload();
                        this.popupActive=false
                        this.getAlumnos()
                        // console.log(response.data)
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Profesor Asignado',
                            text: 'Se ha guardado la asignacion correctamente'
                        })
                        //this.alumnos_grupo = response.data.alumnos_grupo;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getAlumnos() {
                this.$http.get("alumnos_carrera_estancia_periodo/" + this.carrera + "/" + this.cuatrimestre_actual[0].idAgno + "/" + this.cuatrimestre_actual[0].idPeriodo).then(
                    response => {
                        // console.log(response.data)
                        this.alumnos = response.data.alumnos;
                        //console.log(this.kardex);
                        this.$vs.loading.close();

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getProfesores() {
                this.$http.get("profesores_carrera/" + this.carrera).then(
                    response => {
                        // console.log(response.data)
                        this.profesores = response.data.profesores;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            getCarreras() {
                this.$http.get("carreras").then(
                    response => {
                        // console.log(response.data)
                        this.carreras = response.data.carreras;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
                this.$http.get("carrera_id/" + this.carrera).then(
                    response => {
                        // console.log(response.data)
                        this.carreras_select = response.data.carrera;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
            asignar_profesor(alumno){
                this.popupActive=true
                this.alumno_asignar = alumno.idAlumno
                this.grupo_asignar = alumno.idGrupo
                //localStorage.setItem('cuenta', alumno.matricula)
              //  localStorage.setItem('id_alumno', alumno.matricula)

                      //     this.$router.push('/directores/materias_alumno_director')




            },
            ver_kardex(alumno){

                // localStorage.setItem('id_grupo', grupo)
                localStorage.setItem('cuenta', alumno.matricula)
                localStorage.setItem('id_alumno', alumno.matricula)

                this.$router.push('/directores/kardex')




            }
        },
    }
</script>
